import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";
import { path } from "src/routes/paths";

const Ewallet = Loadable(
  lazy(() => import("src/pages/admin/financial/ewallet"))
);
const PendingWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/pending"))
);
const DepositWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/deposit"))
);
// const MiningProfit = Loadable(
//   lazy(() => import("src/pages/admin/financial/mining-profit"))
// );
const FundCredits = Loadable(
  lazy(() => import("src/pages/admin/financial/fundCredit/index"))
);
const Payout = Loadable(
  lazy(() => import("src/pages/admin/financial/payout/index"))
);
const PayoutRequest = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/payout/components/request/index")
  )
);
const PayoutHistory = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/payout/components/history/index")
  )
);
const FinancialReport = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/financialReport/financialReport")
  )
);

const LatestSales = Loadable(
  lazy(() => import("src/pages/admin/financial/sales/index"))
);
// const BinaryCommission = Loadable(
//   lazy(() => import("src/pages/admin/financial/binary-commission/list/index"))
// );
// const BinaryCommissionDetails = Loadable(
//   lazy(() => import("src/pages/admin/financial/binary-commission/details/index"))
// );

const CommissionPeriod = Loadable(
  lazy(() => import("src/pages/admin/financial/commission-period/index"))
);

const SalesRepresantative = Loadable(
  lazy(() => import("src/pages/admin/financial/sales-represantative/index"))
);

// const AdjustmentHistory = Loadable(
//   lazy(() => import("src/pages/admin/financial/adjustment-history/index"))
// );

const financial = [
  {
    path: "financial",
    children: [
      { element: <Navigate to="deposit-wallet" />, index: true },
      // { path: "e-wallet", element: <Ewallet /> },
      // { path: "pending-wallet", element: <PendingWallet /> },
      { path: "deposit-wallet", element: <DepositWallet /> },
      // { path: "mining-profit", element: <MiningProfit /> },
      { path: "fund-credits", element: <FundCredits /> },
      {
        path: "payout",
        element: <Payout />,
        children: [
          { index: true, element: <Navigate to="request" replace /> },
          { path: "request", element: <PayoutRequest /> },
          { path: "history", element: <PayoutHistory /> },
        ],
      },
      // {
      //   path: "binary-commission",
      //   children: [
      //     { index: true, element: <BinaryCommission /> },
      //     {
      //       path: ":id",
      //       element: <BinaryCommissionDetails />,
      //     },
      //   ],
      // },
      // {
      //   path: "commission",
      //   element: <Admission />,
      // },
      { path: "commission-period", element: <CommissionPeriod /> },
      { path: "report", element: <FinancialReport /> },
      { path: "sales", element: <LatestSales /> },
      { path: "sales-represantative", element: <SalesRepresantative /> },
      // {path: "adjustment-history", element: <AdjustmentHistory />},
    ],
  },
];

export default financial;

